import gql from "graphql-tag";

export const CREATE_OTP = gql`
  mutation createOtp($input: OtpInput!) {
    createOtp (input: $input) {
      otp {
        receiver
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation verifyOtp($input: VerifyOtpInput!) {
    verifyOtp (input: $input) {
      otp {
        id
        receiver
        value
        status
      }
      verified
      errors {
        field
        message
      }
    }
  }
`;
